"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimestampEditor = void 0;

var _react = _interopRequireWildcard(require("react"));

var _firebase = require("../firebase");

var _util = require("../util");

var _Video = require("./Video");

var _excluded = ["timestampKey", "firestoreDoc", "src"],
    _excluded2 = ["videoRef", "src", "timestamps", "setTimestamps", "duration", "curTime", "barRootRef"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TimestampEditor = {
  Video: /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
    var timestampKey = _ref.timestampKey,
        firestoreDoc = _ref.firestoreDoc,
        src = _ref.src,
        props = _objectWithoutProperties(_ref, _excluded);

    var videoRef = (0, _react.useRef)();
    var timestampState = TimestampEditor.useState({
      videoRef: videoRef,
      timestampKey: timestampKey,
      firestoreDoc: firestoreDoc,
      src: src
    });
    (0, _react.useImperativeHandle)(ref, function () {
      return _objectSpread({}, timestampState);
    }, [timestampState]);
    return /*#__PURE__*/_react.default.createElement(_Video.Video.Container, {
      ref: videoRef,
      src: src,
      style: {
        width: "50vw"
      }
    }, /*#__PURE__*/_react.default.createElement(_Video.Video.PlayButton, {
      autoplay: false
    }), timestampKey && /*#__PURE__*/_react.default.createElement(TimestampEditor.Bar, timestampState), /*#__PURE__*/_react.default.createElement(_Video.Video.Fullscreen, null));
  }),
  useState: function useState(_ref2) {
    var timestampKey = _ref2.timestampKey,
        firestoreDoc = _ref2.firestoreDoc,
        videoRef = _ref2.videoRef,
        src = _ref2.src;

    var _useState2 = (0, _react.useState)([]),
        _useState3 = _slicedToArray(_useState2, 2),
        timestamps = _useState3[0],
        _setTimestamps = _useState3[1];

    var _useState4 = (0, _react.useState)(0),
        _useState5 = _slicedToArray(_useState4, 2),
        curTime = _useState5[0],
        setCurTime = _useState5[1];

    var _useState6 = (0, _react.useState)(0),
        _useState7 = _slicedToArray(_useState6, 2),
        duration = _useState7[0],
        setDuration = _useState7[1];

    var _useFirestoreVariable = (0, _firebase.useFirestoreVariableDoc)(firestoreDoc),
        _useFirestoreVariable2 = _slicedToArray(_useFirestoreVariable, 1),
        curValueState = _useFirestoreVariable2[0];

    var barRootRef = (0, _react.useRef)();

    var validTimestamps = function validTimestamps(t) {
      var _videoRef$current;

      t = !((_videoRef$current = videoRef.current) !== null && _videoRef$current !== void 0 && _videoRef$current.duration) ? [0].concat(_toConsumableArray(t)) : [0].concat(_toConsumableArray(t), [videoRef.current.duration]);
      return Array.from(new Set(t)).sort(function (a, b) {
        return a - b;
      });
    };

    var setTimestamps = function setTimestamps(x) {
      if (x instanceof Function) _setTimestamps(function (t) {
        return validTimestamps(x(t));
      });else _setTimestamps(validTimestamps(x));
    }; // reset timestamps when loading new video


    (0, _react.useEffect)(function () {
      var _videoRef$current2;

      setTimestamps((curValueState === null || curValueState === void 0 ? void 0 : curValueState[timestampKey]) || []);
      (_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.focus();
    }, [firestoreDoc, timestampKey, curValueState]);

    function updateTimes() {
      var _videoRef$current3, _videoRef$current4;

      setCurTime(((_videoRef$current3 = videoRef.current) === null || _videoRef$current3 === void 0 ? void 0 : _videoRef$current3.currentTime) || 0);
      setDuration(((_videoRef$current4 = videoRef.current) === null || _videoRef$current4 === void 0 ? void 0 : _videoRef$current4.duration) || 0);
    }

    (0, _util.useRefListener)(videoRef, 'loadedmetadata', updateTimes, [src]); // sync duration state for newly loaded videos

    (0, _util.useRefListener)(videoRef, 'timeupdate', updateTimes, [src]); // update state on all timeupdate events
    // edit timestamps

    var handleKeyDown = function handleKeyDown(e) {
      switch (e.key) {
        case " ":
          e.preventDefault();
          if (!e.repeat) setTimestamps(function (t) {
            return [].concat(_toConsumableArray(t), [videoRef.current.currentTime]);
          });
          break;

        case "ArrowLeft":
          // TODO easier editing of timestamps
          break;
      }
    }; // apply keydown listener to video parent box


    (0, _react.useEffect)(function () {
      var _videoRef$current5;

      var cur = (_videoRef$current5 = videoRef.current) === null || _videoRef$current5 === void 0 ? void 0 : _videoRef$current5.parentNode;

      if (cur) {
        cur.tabIndex = 0; // keydown wont work if you cant focus on the element

        cur.addEventListener('keydown', handleKeyDown, true);
        return function () {
          return cur.removeEventListener('keydown', handleKeyDown);
        };
      }
    }, [videoRef, src]);
    return {
      timestamps: timestamps,
      setTimestamps: setTimestamps,
      duration: duration,
      curTime: curTime,
      barRootRef: barRootRef
    };
  },
  Bar: function Bar(_ref3) {
    var videoRef = _ref3.videoRef,
        src = _ref3.src,
        timestamps = _ref3.timestamps,
        setTimestamps = _ref3.setTimestamps,
        duration = _ref3.duration,
        curTime = _ref3.curTime,
        barRootRef = _ref3.barRootRef,
        props = _objectWithoutProperties(_ref3, _excluded2);

    var _useState8 = (0, _react.useState)(undefined),
        _useState9 = _slicedToArray(_useState8, 2),
        selectedTimestamp = _useState9[0],
        setSelectedTimestamp = _useState9[1];

    var seekTime = function seekTime(seekFrac) {
      return seekFrac * duration || 0;
    };

    var seek = function seek(time) {
      var video = videoRef.current;
      if (video.fastSeek) video.fastSeek(time);else video.currentTime = time;
    };

    var seekClosestTimestamp = function seekClosestTimestamp(e) {
      var video = videoRef.current,
          bar = barRootRef.current;
      var xFraction = (e.clientX - bar.getBoundingClientRect().left) / bar.offsetWidth;

      if (timestamps.length > 0) {
        var closestTime = (0, _util.findClosest)(timestamps, seekTime(xFraction));
        setSelectedTimestamp(closestTime);
        seek(closestTime);
      } else {
        seek(seekTime(seekFraction));
      }
    };

    var drag = function drag(e) {
      if (e.buttons == 1) {
        seekClosestTimestamp(e);
      }
    };

    return /*#__PURE__*/_react.default.createElement("div", _extends({
      ref: barRootRef,
      className: "progressBar"
    }, props, {
      onClick: seekClosestTimestamp
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "bar",
      style: {
        backgroundColor: "#aaa",
        width: "".concat(100 * curTime / duration, "%")
      }
    }), timestamps.map(function (t) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "starMarker",
        key: t,
        style: {
          left: "".concat(100 * t / duration, "%"),
          fontSize: t == selectedTimestamp ? "1.5rem" : ".8rem"
        }
      }, "\u27E1");
    })
    /** ⟡♦◆⬥ */
    , /*#__PURE__*/_react.default.createElement("i", {
      className: "marker fas fa-trash",
      style: {
        left: "100%"
      },
      onClick: function onClick() {
        return setTimestamps([]);
      }
    }));
  }
};
exports.TimestampEditor = TimestampEditor;